import { default as DomainFormDefault } from './DomainForm/View';
import { default as DomainForm4 } from '../../themes/4/components/Domains/DomainForm';
import themedComponent from '../../hoc/ThemedComponent';

const ThemedDomainForms = {
  default: DomainFormDefault,
  // 4: DomainForm4,
};

export const DomainFormView = themedComponent(ThemedDomainForms);
